import { BuilderViewType, DeskingConfigurationBaseOnAccount, SaleStructureType, SaleType } from '../types';

const NTP_PROD_ACCOUNT_ID = 'af389c24-71db-11ef-b67d-438054f5b5e6';
const NTP_DEV_ACCOUNT_ID = 'aebc4dfe-71db-11ef-a943-db9302946276';

const NTP_CONFIG: Partial<DeskingConfigurationBaseOnAccount> = {
  saleMode: {
    isCash: true,
    isFinancing: false,
    saleType: SaleType.Cash,
    saleStructureType: SaleStructureType.AftermarketMenu,
  },
  formFieldsRequire: {
    'equipment.mileage': {
      value: true,
      message: 'Required field',
    },
    'equipment.serialNumberVin': {
      value: true,
      message: 'Required field',
    },
  },
  displaySettings: {
    excludeEquipmentSales: true,
  },
  notifications: {
    menuBuilder: 'Serial/VIN#, Mileage require fields for interaction with products',
  },
  state: {
    menuBuilderViewType: BuilderViewType.AftermarketMenu,
  },
};

export const deskingConfigByAccId: Record<string, Partial<DeskingConfigurationBaseOnAccount>> = {
  [NTP_DEV_ACCOUNT_ID]: NTP_CONFIG,
  [NTP_PROD_ACCOUNT_ID]: NTP_CONFIG,
};
